/**
 * SteamDB — Steam store / community enrichment
 *
 * Declares two WAR entries, both static (no use_dynamic_url) but origin-scoped: one exposes
 * icons, styles and injected scripts to the Steam store and community sites, the other
 * re-exposes `options/options.html` to steamdb.info. So the resources sit at fixed URLs but
 * only those origins can reach them; from anywhere else the fetch fails and a negative
 * result proves nothing. We probe from store.steampowered.com.
 *
 * Manifest verified against version 4.35.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kdbmhfkmnlmbkgbabkdealhhbfhlmmon';

export const steamdb: ExtensionDefinition = {
  id: ID,
  name: 'SteamDB',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  requiredOrigin: 'https://store.steampowered.com',
  notes:
    'Static WAR scoped to Steam store/community (and steamdb.info), so only those sites ' +
    'can detect it. A single fetch there is conclusive.',
  signals: [
    {
      id: 'war-appicon-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch styles/appicon.css — a vendor-named stylesheet, static but only exposed to ' +
        'the Steam origins.',
      weight: 1,
      run: () => probeFetch(ID, 'styles/appicon.css'),
    },
    {
      id: 'war-pcgamingwiki-svg',
      kind: 'web-accessible-resource',
      description: 'Fetch icons/pcgamingwiki.svg — a second origin-scoped static resource.',
      weight: 0.5,
      run: () => probeFetch(ID, 'icons/pcgamingwiki.svg'),
    },
    {
      id: 'war-steamhunters-svg',
      kind: 'web-accessible-resource',
      description:
        'Fetch icons/steamhunters.svg — a third origin-scoped icon, independent of the ' +
        'others.',
      weight: 0.5,
      run: () => probeFetch(ID, 'icons/steamhunters.svg'),
    },
  ],
};
